const aboutData = {

    features : [
                    {
                      id: 1,
                      icon: 'bi-truck',
                      title: 'Livraison rapide',
                      desc: 'Livraison sécurisée et dans les délais convenus.',
                      bg: '#f37021'
                    },
                    {
                      id: 2,
                      icon: 'bi-cash-stack',
                      title: 'Solution économique',
                      desc: 'Des services et produits adaptés à votre budget.',
                      bg: '#1fb5ad'
                    },
                    {
                      id: 3,
                      icon: 'bi-book',
                      title: 'Expertise reconnue',
                      desc: 'Conseils et accompagnement par nos experts.',
                      bg: '#964b00'
                    },
                    {
                      id: 4,
                      icon: 'bi-building',
                      title: 'Partenariats solides',
                      desc: 'Collaborations pour des solutions innovantes.',
                      bg: '#006a4e'
                    }
               ],

    services :   [
                    { id: 1, 
                      title: 'Équipements biomédicaux' 
                    },
                    { id: 2, 
                      title: 'Équipements informatiques' 
                    },
                    { id: 3, 
                      title: 'Services de maintenance' 
                    },
                    { id: 4, 
                      title: 'Logiciels professionnels' 
                    },
                 ],


}


export default aboutData;